import { RouteRecordRaw } from 'vue-router';
import MiddlePageOpenApp from './middle-page-logout.vue';

export const ROUTE_NAME_MIDDLE_LOGOUT = 'middle-page-logout';
export const middlePageLogoutRouter: RouteRecordRaw[] = [
  {
    path: '/middle-page-logout',
    name: ROUTE_NAME_MIDDLE_LOGOUT,
    component: MiddlePageOpenApp,
  },
];
